import { setEnvironment } from '../environment';

export const environment = setEnvironment({
  APPLICATION_NAME: 'RoughagePlus',
  API_BASE_URL: 'http://localhost:4200',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'http://localhost:4200',
  LOGIN_TYPE: 'redirect',
  SIGNUP_SIGNIN_POLICY: 'B2C_1A_AllAccountsSignupSignin',
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  APPLICATION_KEY: 'RoughagePlus',
  APP_INSIGHTS_KEY: '',
  DEFAULT_LOCALE: 'nl-NL',
  LOCALES: 'nl-NL,en-US',
  PRODUCTION: 'true',
  RELATIONSHIPS_ELASTIC_SEARCH: 'true',
});
